import { UspsDirectRateType } from "@redotech/redo-model/carrier-account/carrier-account";
import {
  InputProvider,
  groupInput,
  input,
  nonEmptyValidator,
} from "@redotech/ui/form";
import { memo } from "react";
import { RedoTextInput } from "../../../../arbiter-components/input/redo-text-input";
import { RedoRadioGroup } from "../../../../arbiter-components/radio/redo-radio-group";

export const UspsDirectCarrierInput = groupInput({
  accountNumber: input<string>({ validator: nonEmptyValidator }),
  customerRegistrationId: input<string>({ validator: nonEmptyValidator }),
  mailerId: input<string>({ validator: nonEmptyValidator }),
  manifestMailerId: input<string>({ validator: nonEmptyValidator }),
  rateType: input<UspsDirectRateType>({ validator: nonEmptyValidator }),
});

export type UspsDirectCarrierValue = InputProvider.Value<
  typeof UspsDirectCarrierInput
>;

export type UspsDirectCarrierForm = InputProvider.Form<
  typeof UspsDirectCarrierInput
>;

export const uspsDirectCarrierDefault = (): UspsDirectCarrierValue => ({
  accountNumber: "",
  customerRegistrationId: "",
  mailerId: "",
  manifestMailerId: "",
  rateType: UspsDirectRateType.REDO_RATES,
});

const rateTypeOptions = [
  {
    id: UspsDirectRateType.MERCHANT_RATES,
    label: "Merchant rates",
    description: "Pay for your own contract rates",
  },
  {
    id: UspsDirectRateType.REDO_RATES,
    label: "Redo rates",
    description: "Pay for Redo's rates with your own USPS account",
  },
];

export const CreateUspsDirectCarrierForm = memo(
  function CreateUspsDirectCarrierForm({
    carrierInput,
  }: {
    carrierInput: UspsDirectCarrierForm;
  }) {
    return (
      <>
        <RedoTextInput
          description="The account number that will be used to pay for labels"
          label="EPS Account Number"
          placeholder="Enter EPS account number"
          setValue={carrierInput.inputs.accountNumber.setValue}
          value={carrierInput.inputs.accountNumber.value}
        />
        <RedoTextInput
          label="Customer Registration ID (CRID)"
          placeholder="Enter customer registration ID"
          setValue={carrierInput.inputs.customerRegistrationId.setValue}
          value={carrierInput.inputs.customerRegistrationId.value}
        />
        <RedoTextInput
          label="Mailer ID (MID)"
          placeholder="Enter mailer ID"
          setValue={carrierInput.inputs.mailerId.setValue}
          value={carrierInput.inputs.mailerId.value}
        />
        <RedoTextInput
          label="Manifest Mailer ID (Manifest MID)"
          placeholder="Enter manifest mailer ID"
          setValue={carrierInput.inputs.manifestMailerId.setValue}
          value={carrierInput.inputs.manifestMailerId.value}
        />
        <RedoRadioGroup
          label="Rate type"
          options={rateTypeOptions}
          setValue={carrierInput.inputs.rateType.setValue}
          value={carrierInput.inputs.rateType.value}
        />
      </>
    );
  },
);
